import { Box, Typography } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import React from 'react';

function UnitNode({ data: { unit } }) {
  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        px: 2,
        py: 1,
        borderRadius: 1,
      }}
    >
      <Typography>{unit.name}</Typography>
      <Typography>{unit.subtitle}</Typography>
      <Handle
        type="target"
        position={Position.Top}
        style={{ visibility: 'hidden' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ visibility: 'hidden' }}
      />
    </Box>
  );
}

export default UnitNode;
